<template>
  <div class="ProductApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='2'></headComponent>
    <div class="h"></div>
    <div class="proBg"  :style="'background: url('+proBg+') no-repeat center;'">
      关于产品
    </div>

    <div class="main">
      <dl v-for="(item,i) in setProduct">
        <dt>{{item.title}}</dt>
        <dd v-for="(vo,k) in item.jsonStr">
          <a href="javascript:;" @click="$router.push('detail?id='+vo.id)">
            <div class="tit">
              <div class="tips">{{vo.tips}}</div>
              <h3>{{vo.title}}</h3>
            </div>
            <div class="pic">
              <img :src="baseUrl+vo.images" alt="">
            </div>
            <span class="btn">了解更多  &gt;</span>
          </a>
        </dd>
      </dl>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proBg:require('../../../assets/images/probg.png'),
        setProduct:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getProduct();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getProduct:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/product',
          dataType:'json',
          success:function(data){
            that.setProduct = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .ProductApp .el-message-box{
    width:30%
  }
  .ProductApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .ProductApp .h{
    height:96px
  }
  .ProductApp .proBg{
    height:150px;
    color:#fff;
    font-size: 2vw;
    padding-left:8.333vw;
    line-height:150px;
  }

  .ProductApp .main{
    margin:0 auto;
    max-width:1600px;
  }
  .ProductApp .main dl dt{
    font-size:20px;
    font-weight:bold;
    padding:25px 0 12px 0
  }
  .ProductApp .main dl dd{
    float:left;
    width:25%;
    margin-bottom:12px;
  }
  .ProductApp .main dl:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .ProductApp .main dl dd a{
    display: block;
    background-color: #fff;
    margin: 0 12px 0 0;
    padding-bottom:25px;
  }
  .ProductApp .main dl dd a .tit{
    margin-bottom:20px;
    text-align:center;
    padding-top: 2.447vw;
  }
  .ProductApp .main dl dd a .tit .tips{
    color: #888;
    font-size:15px;
    padding-bottom:12px
  }
  .ProductApp .main dl dd a .tit h3{
    color: #111;
    font-size: 1.25vw;
    width:90%;
    margin:0 auto
  }
  .ProductApp .main dl dd a .pic img{
    display:block;
    margin:0 auto 30px auto;
    object-fit: cover;
    height:200px;
  }
  .ProductApp .main dl dd a  .btn{
    border: 1px solid rgba(51,51,51,.2);
    color: #777;
    display: block;
    width:60%;
    margin:0 auto;
    height:35px;
    text-align:center;
    line-height:35px;
    font-size:15px;
  }
  .ProductApp .main dl dd a:hover .btn{
    border-color: #4470AF;
    background-color: #4470AF;
    color: #fff;
  }
  
  @media only screen and (max-width: 1199px) {
    .ProductApp .header,.ProductApp .h{
      height:60px;
    }
    .ProductApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .ProductApp .header .nav{
      text-align:right
    }
    .ProductApp .header .nav li{
      margin:0 1.8vw
    }
    .ProductApp .header .nav .close{
      display:none
    }
    .ProductApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .ProductApp .proBg{
      font-size:18px;
    }
    .ProductApp .main dl dd{
      width:50%
    }

    .ProductApp .main dl dd a .pic img{
      width:100%;
      height:140px
    }
    .ProductApp .main dl dd a .tit h3{
      font-size:16px
    }
  } 
</style>